module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/crG0vY/tc-custom/9781617454097.jpg?1696085809190",
      "alt": "This image is the cover for the book Make 1-Hour Gifts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Make 1-Hour Gifts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This ideal guide for the busy sewist features 16 fast and fun projects by some of today’s top designers.")]), _c('br'), _c('br'), _vm._v("Now it’s easy to fit a sewing project into your busy day. With "), _c('i', [_vm._v("Make 1-Hour Gifts")]), _vm._v(", you can sew delightful coasters, aprons, bibs, bags, accessories and more—all in record time! This volume features designs by Abbey Lane Quilts, Katy Dill, Annabel Wrigley and many others. Each project is designed to be completed in 60 minutes or less—plus, there’s a special section of 30-minute projects!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Abbey Lane Quilts, Alexia Marcelle Abegg, Bari J. Ackerman, Lindsay Conner, Sue Kim, Virginia Lindsay, Trish Preston, Sweetwater, Sara Trail, Kajsa Wikman, Annabel Wrigley\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing, Inc.,\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0